<template>
  <v-slide-y-transition mode="out-in">
    <v-layout row wrap v-if="contentStatusMessage.alertVisible">
      <v-flex xs12 px-3>
        <v-alert
          dismissible
          v-model="contentStatusMessage.alertVisible"
          :type="contentStatusMessage.alertType"
          :icon="contentStatusMessage.alertType"
        >
          <h1>{{contentStatusMessage.heading}}</h1>
          {{contentStatusMessage.content}}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: "ContentStatusMessage",
  computed: {
    contentStatusMessage() {
      return this.$store.state.contentStatusMessage;
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>
